import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

import type { Data } from '@/shared/types/data'

export const EMPTY_DATA: Data = {
  version: '',
  missions: [],
  posts: [],
  documents: [],
  passes: []
} as const

interface DataState {
  data: Data
  setData: (data: Data) => void
  getData: () => Data
}

export const useDataStore = create(
  persist<DataState>(
    (set, get) => ({
      data: EMPTY_DATA,
      setData: data => set({ data }),
      resetData: () => set({ data: EMPTY_DATA }),
      getData: () => get().data
    }),
    {
      name: 'pgee.data',
      storage: createJSONStorage(() => localStorage)
    }
  )
)
